import { ref } from 'vue'
import { defineStore } from 'pinia'
import { ElNotification } from 'element-plus'
import { legacyBridge } from '@/services/legacyBridge'
import { apiClientV1 } from '@/ContextTab/services/apiClient'
import type { ShareManagerState } from '@/lib/types'
import type { TContextId } from '@/ContextTab/stores/types'


type ShareRequestSource = 'ps-ui' | 'publishing-ui' /* legacy */

export const useShareNewsModalStore = defineStore('shareNewsModal', () => {

  const shareModalVisible = ref(false)
  const source = ref<ShareRequestSource>('ps-ui')

  const modalState = ref<ShareManagerState>({
    itemId: null,
    actionType: null,
    hasKeepOriginal: true,
  })

  function showShareModal(state: ShareManagerState, s: ShareRequestSource = 'ps-ui') {
    updateState(state)
    shareModalVisible.value = true
    source.value = s
  }

  function hideShareModal(contextId: TContextId) {
    shareModalVisible.value = false
    if (source.value === 'publishing-ui') {
      legacyBridge.hideShareModal(contextId)
    }
  }

  function updateState(state: ShareManagerState) {
    Object.assign(modalState.value, state)
  }

  async function sendToAsoi(payload: any, news_id: number, contextId: TContextId) {
    if (source.value === 'publishing-ui') {
      legacyBridge.sendToAsoi(contextId, { ...payload, newsItemId: news_id })
    } else {
      const res = await apiClientV1.NewsService.postNewsByNewsIdSendToAsoi({ path: { news_id }, body: payload })
      if (res.error) {
        ElNotification.error({
          title: 'Произошла ошибка при отправке новости в АСОИ',
        })
        return
      }

      ElNotification.success('Новость успешно отправлена в АСОИ')
    }
  }

  async function send(payload: any, news_id: number, contextId: TContextId) {
    if (source.value === 'publishing-ui') {
      legacyBridge.sendNews(contextId, { ...payload, newsItemId: news_id })
    } else {
      const res = await apiClientV1.NewsService.postNewsByNewsIdSend({ path: { news_id }, body: payload })
      if (res.error) {
        ElNotification.error({
          title: 'Произошла ошибка при отправке новости',
        })
        return
      }

      ElNotification.success('Новость успешно отправлена')
    }
  }

  return {
    modalState,
    shareModalVisible,

    showShareModal,
    hideShareModal,

    sendToAsoi,
    send,
  }
})
